import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import React from 'react';

// Utils
import { getTranslateByKey } from '@/main/services/utils';

import { useStyles } from '../inputText/styles';
import { getPatternDate } from '@/main/services/utilsDate';
import * as S from './styles';

const EMPTY_STYLES_PARAMS = {};

interface KogKeyboardDatePickerProps {
  error: boolean;
  id: string;
  value: any;
  name: string;
  label: string;
  onChange: (date: any) => void;
  isFieldInModal?: boolean;
  required?: boolean;
  helperText?: string | null;
  disabled?: boolean;
  fullWidth?: boolean;
  hasBackground?: boolean;
  onBlur?: () => void;
}

export default React.memo(function KogKeyboardDatePicker({
  error,
  id,
  value,
  name,
  label,
  onChange,
  required = false,
  helperText = null,
  disabled = false,
  hasBackground = false,
  onBlur = () => { }
}: KogKeyboardDatePickerProps) {
  const classes = useStyles(EMPTY_STYLES_PARAMS);

  return (
    <S.BoxInputData $isDisabled={disabled} $hasBackground={hasBackground}>
      <DatePicker
        closeOnSelect
        slotProps={{
          textField: {
            className: classes.inputText,
            size: 'small',
            variant: 'filled',
            fullWidth: true,
            helperText: helperText,
            required: required,
            name: name,
            error: error,
            id: id,
            onBlur: () => { onBlur(); }
          }
        }}
        label={label}
        disabled={disabled}
        format={getPatternDate()}
        value={value}
        onChange={(date: any) => {
          onChange(date);
        }}
      />
    </S.BoxInputData>
  );
});
